<!-- WhatsApp Sticky Button Component -->
<template>
  <div class="whatsapp-container" v-if="showButton">
    <a
      :href="whatsappLink"
      class="whatsapp-float"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat with us on WhatsApp"
    >
      <i class="fa-brands fa-whatsapp"></i>
      <span class="visually-hidden">Chat with us on WhatsApp</span>
    </a>
    <span class="whatsapp-tooltip">{{ t("chat_with_us") }}</span>
  </div>
</template>

<script setup>
import { computed, ref, onMounted, reactive } from "vue";
import { useAppartmentStore } from "@/stores/Store";
import { useI18n } from "vue-i18n";

const { t, locale } = useI18n();
const appartmentStore = useAppartmentStore();
const showButton = ref(true);

// Get WhatsApp number from store settings or use default
const whatsappNumber = computed(() => {
  // Get from settings or use a default number
  return state.whatsappNumber;
});

// Get default message based on language
const defaultMessage = computed(() => {
  return locale.value === "ar"
    ? "مرحباً، أرغب في معرفة المزيد عن العقارات المتاحة لديكم."
    : "Hello, I would like to know more about your available properties.";
});

// Create the WhatsApp link with the phone number and pre-filled message
const whatsappLink = computed(() => {
  const cleanNumber = whatsappNumber.value.replace(/[^0-9]/g, "");
  const encodedMessage = encodeURIComponent(defaultMessage.value);
  return `https://wa.me/${cleanNumber}?text=${encodedMessage}`;
});

const state = reactive({
  showButton: false,
  whatsappNumber: "",
});

onMounted(() => {
  appartmentStore.getSettings().subscribe(
    (response) => {
      state.whatsappNumber = response.data.message.data.settings.support_phone;
      state.showButton = true;
    },
    () => {
      state.showButton = false;
    }
  );
});
</script>

<style scoped>
.whatsapp-container {
  position: fixed;
  bottom: 30px; /* Reduced from 120px to bring it closer to bottom */
  left: 30px;
  z-index: 100;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.whatsapp-float {
  width: 60px;
  height: 60px;
  background-color: #25d366;
  color: #ffffff !important; /* Force white color */
  border-radius: 50px;
  text-align: center;
  font-size: 30px;
  box-shadow: 2px 2px 8px rgba(0, 0, 0, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
}

.whatsapp-float i {
  color: #ffffff !important; /* Explicitly set icon to white */
}

.whatsapp-tooltip {
  position: absolute;
  top: -40px;
  left: 0;
  background-color: #ffffff;
  color: #000000;
  padding: 5px 12px;
  border-radius: 5px;
  font-size: 15px;
  font-weight: 600;
  white-space: nowrap;
  opacity: 0;
  transition: opacity 0.3s ease;
  pointer-events: none;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
  border: 1px solid #e0e0e0;
}

.whatsapp-container:hover .whatsapp-tooltip {
  opacity: 1;
}

.whatsapp-float:hover {
  background-color: #20ba5a;
  color: #fff;
  transform: scale(1.1);
}

/* Animation effect */
@keyframes pulse {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(1);
  }
}

.whatsapp-float {
  animation: pulse 2s infinite;
}

/* Stop animation on hover */
.whatsapp-float:hover {
  animation: none;
}
</style>
